export default __webpack_public_path__ + "static/media/DSC_9074.1f5fb9bf.jpg";